import { render, staticRenderFns } from "./configRewards.vue?vue&type=template&id=9c8e9c28&scoped=true&"
import script from "./configRewards.vue?vue&type=script&lang=js&"
export * from "./configRewards.vue?vue&type=script&lang=js&"
import style0 from "./configRewards.vue?vue&type=style&index=0&id=9c8e9c28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8e9c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c8e9c28')) {
      api.createRecord('9c8e9c28', component.options)
    } else {
      api.reload('9c8e9c28', component.options)
    }
    module.hot.accept("./configRewards.vue?vue&type=template&id=9c8e9c28&scoped=true&", function () {
      api.rerender('9c8e9c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/configRewards.vue"
export default component.exports